"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var LftListMenuItem_styles_1 = require("./LftListMenuItem.styles");
var LftListMenuItem = function (_a) {
    var _b, _c;
    var children = _a.children, dataElement = _a.dataElement, dataInfo = _a.dataInfo, focused = _a.focused, id = _a.id, index = _a.index, selected = _a.selected, value = _a.value, lftClick = _a.lftClick;
    var _handleClick = function () {
        lftClick &&
            lftClick({
                detail: {
                    index: index,
                    value: value,
                },
            });
    };
    var _handleKeydown = function (event) {
        switch (event.key) {
            case 'Enter':
            case 'Space':
                _handleClick();
                break;
        }
    };
    if (dataElement) {
        if (dataElement.includes('_')) {
            if (typeof window !== 'undefined' && (((_b = window.location.href) === null || _b === void 0 ? void 0 : _b.indexOf('localhost')) > -1 || ((_c = window.location.href) === null || _c === void 0 ? void 0 : _c.indexOf('dev')) > -1)) {
                console.warn('Não é necessário mais colocar o prefixo no atributo dataElement');
            }
        }
        else {
            dataElement = "option_" + dataElement;
        }
    }
    return ((0, jsx_runtime_1.jsx)(LftListMenuItem_styles_1.LftListMenuItemStyled, __assign({ "aria-selected": selected, className: focused ? 'focused' : '', "data-element": dataElement, "data-info": dataInfo, "data-lift": "lft-menuitem", id: id, role: "option", tabIndex: 0, onClick: _handleClick, onKeyDown: _handleKeydown }, { children: children }), void 0));
};
exports.default = LftListMenuItem;
